module.exports = __webpack_public_path__ + "static/media/payout_icon.bf1589b2.jpg";